export default __webpack_public_path__ + "065eaa949378a1e213f78959f6379555.png";